import { Directive, ElementRef, Input } from '@angular/core';
import { Utility } from 'src/app/core/common';

@Directive({
  selector: '[sms-to]'
})
export class SmsDirective {

  @Input('sms-to') to: string;
  @Input('sms-body') body: string;
  constructor(private anchor: ElementRef<HTMLAnchorElement>) { }
  ngOnInit(): void {
    this.anchor.nativeElement.href = `sms:+${this.to}${Utility.iOS ? '&' : '?'}body=${this.body}`;
  }
}
